// @flow
import * as React from 'react';
import styled from 'styled-components';
import colorByProduct from '../customThemes';

const BadgeSpan = styled.span`
  padding: 2px 2px;
  border-radius: 50%;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  display: inline;
  color: ${colorByProduct('badgeText')};
  background: ${colorByProduct('badgeBackgroud')};
`;

export default function Badge(props: {
  className?: string;
  children: React.ReactNode;
}) {
  return <BadgeSpan className={props.className}>{props.children}</BadgeSpan>;
}
